export const normalizeReturnsFormData = apiData => {
  if (!apiData) return {}

  const { deductorDetails = {}, responsiblePerson = {} } = apiData

  return {
    // -------- Particulars of Statement --------
    uuid: apiData.uuid || '',
    tanNumber: apiData.tan || '',
    lastTan: apiData.lastTan || '',
    pan: apiData.pan || '',
    financialYear: apiData.financialYear || '',
    assessmentYear: apiData.assessmentYear || '',
    revisedReturn: apiData.revisedReturn == true ? 'Yes' : 'No',
    deductorType: apiData.deductorType || '',
    previousReturnReceiptNo: apiData.previousReturnReceiptNo || '',
    originalReturnReceiptNo: apiData.originalReturnReceiptNo || '',
    lastDeductorType: apiData.lastDeductorType || '',
    updateDeductorDetails: apiData.updateDeductorDetails || '',
    formType: apiData.formType || '',
    returnType: apiData.returnType || '',
    quarterEnded: apiData.quarterEnded || '',

    // -------- Deductor (Employer) --------
    name: deductorDetails.name || '',
    buildingName: deductorDetails.buildingName || '',
    branchOrDivision: deductorDetails.branchOrDivision || '',
    employerStreet: deductorDetails.roadOrStreet || '',
    areaOrLocation: deductorDetails.areaOrLocation || '',
    townDistrictCity: deductorDetails.townDistrictCity || '',
    state: deductorDetails.state || '',
    pinCode: deductorDetails.pinCode || '',
    email: deductorDetails.email || '',
    stdCode: deductorDetails.stdCode || '',
    telephoneNo: deductorDetails.telephoneNo || '',
    alternateEmail: deductorDetails.alternateEmail || '',
    alternateStdCode: deductorDetails.alternateStdCode || '',
    alternateTelephoneNo: deductorDetails.alternateTelephoneNo || '',
    roadOrStreet: deductorDetails.roadOrStreet || '',
    flatNo: deductorDetails.flatNo || '',
    stateName: deductorDetails.stateName || '',
    gstn: deductorDetails.gstn || '',
    paoCode: deductorDetails.paoCode || '',
    ddoCode: deductorDetails.ddoCode || '',
    ministryName: deductorDetails.ministryName || '',
    ministryNameOther: deductorDetails.ministryNameOther || '',
    paoRegistrationNo: deductorDetails.paoRegistrationNo || '',
    ddoRegistrationNo: deductorDetails.ddoRegistrationNo || '',
    addressChangedSinceLastReturn:
      deductorDetails.addressChangedSinceLastReturn === null ||
      deductorDetails.addressChangedSinceLastReturn === undefined
        ? null
        : deductorDetails.addressChangedSinceLastReturn === true
          ? 'Yes'
          : 'No',

    accountOfficeIdNumber: deductorDetails.accountOfficeIdNumber || '',
    country: deductorDetails.country || 'INDIA',
    // -------- Responsible Person --------
    responsiblePersonName: responsiblePerson.name || '',
    responsiblePersonPAN: responsiblePerson.pan || '',
    responsiblePersonBuilding: responsiblePerson.buildingName || '',
    responsiblePersonDesignation: responsiblePerson.designation || '',
    responsiblePersonArea: responsiblePerson.areaOrLocation || '',
    responsiblePersonFlat: responsiblePerson.flatNo || '',
    responsiblePersonState: responsiblePerson.state || '',
    responsiblePersonStreet: responsiblePerson.roadOrStreet || '',
    responsiblePersonPIN: responsiblePerson.pinCode || '',
    responsiblePersonCity: responsiblePerson.townDistrictCity || '',
    responsiblePersonMobile: responsiblePerson.mobileNo || '',
    responsiblePersonEmail: responsiblePerson.email || '',
    responsiblePersonEmailAlt: responsiblePerson.alternateEmail || '',
    responsiblePersonSTD: responsiblePerson.stdCode || '',
    responsiblePersonTelephone: responsiblePerson.telephoneNo || '',
    responsiblePersonSTDAlt: responsiblePerson.alternateStdCode || '',
    responsiblePersonTelephoneAlt: responsiblePerson.alternateTelephoneNo || '',
    responsiblePersonMobile: responsiblePerson.mobileNo || '',
    responsiblePersonAddressChanged:
      responsiblePerson.addressChangedSinceLastReturn === null ||
      responsiblePerson.addressChangedSinceLastReturn === undefined
        ? null
        : responsiblePerson.addressChangedSinceLastReturn === true
          ? 'Yes'
          : 'No',
    responsiblePersonRegularStatement:
      responsiblePerson.regularStatementFiledEarlier === null ||
      responsiblePerson.regularStatementFiledEarlier === undefined
        ? null
        : responsiblePerson.regularStatementFiledEarlier === true
          ? 'Yes'
          : 'No',
    responsiblePersonReceiptNumber:
      responsiblePerson.earlierStatementReceiptNo || '',
  }
}

export const denormalizeReturnsFormData = (formData, quarter) => ({
  quarter,
  uuid: formData.uuid || '',
  formType: formData.formType || '',
  returnType: formData.returnType || '',
  financialYear: formData.financialYear || '',
  tan: formData.tanNumber || '',
  lastTan: formData.lastTan || '',
  pan: formData.pan || '',
  deductorType: formData.deductorType || '',
  lastDeductorType: formData.lastDeductorType || '',
  updateDeductorDetails: formData.updateDeductorDetails || '',
  assessmentYear: formData.assessmentYear || '',
  quarterEnded: formData.quarterEnded || '',
  revisedReturn: formData.isRevisedReturn == 'Yes' ? true : false,
  previousReturnReceiptNo: formData.previousReturnReceiptNo || '',
  originalReturnReceiptNo: formData.originalReturnReceiptNo || '',
  deductorDetails: {
    uuid: formData.deductorDetailsUuid || null,
    name: formData.name || '',
    buildingName: formData.buildingName || '',
    branchOrDivision: formData.branchOrDivision || '',
    roadOrStreet: formData.roadOrStreet || '',
    areaOrLocation: formData.areaOrLocation || '',
    townDistrictCity: formData.townDistrictCity || '',
    flatNo: formData.flatNo || '',
    state: formData.state || '',
    stateName: formData.stateName || '',
    pinCode: formData.pinCode || '',
    email: formData.email || '',
    alternateEmail: formData.alternateEmail || '',
    stdCode: formData.stdCode || '',
    telephoneNo: formData.telephoneNo || '',
    alternateStdCode: formData.alternateStdCode || '',
    alternateTelephoneNo: formData.alternateTelephoneNo || '',
    addressChangedSinceLastReturn:
      formData.addressChangedSinceLastReturn === 'Yes'
        ? true
        : formData.addressChangedSinceLastReturn === 'No'
          ? false
          : null,
    gstn: formData.gstn || '',
    ministryName: formData.ministryName || '',
    ministryNameOther: formData.ministryNameOther || '',
    paoCode: formData.paoCode || '',
    ddoCode: formData.ddoCode || '',
    paoRegistrationNo: formData.paoRegistrationNo || '',
    ddoRegistrationNo: formData.ddoRegistrationNo || '',
    accountOfficeIdNumber: formData.accountOfficeIdNumber || '',
    country: formData.country || 'INDIA',
  },
  responsiblePerson: {
    uuid: formData.responsiblePersonUuid || '',
    name: formData.responsiblePersonName || '',
    pan: formData.responsiblePersonPAN || '',
    buildingName: formData.responsiblePersonBuilding || '',
    designation: formData.responsiblePersonDesignation || '',
    areaOrLocation: formData.responsiblePersonArea || '',
    flatNo: formData.responsiblePersonFlat || '',
    state: formData.responsiblePersonState || '',
    roadOrStreet: formData.responsiblePersonStreet || '',
    pinCode: formData.responsiblePersonPIN || '',
    townDistrictCity: formData.responsiblePersonCity || '',
    mobileNo: formData.responsiblePersonMobile || '',
    email: formData.responsiblePersonEmail || '',
    alternateEmail: formData.responsiblePersonEmailAlt || '',
    stdCode: formData.responsiblePersonSTD || '',
    telephoneNo: formData.responsiblePersonTelephone || '',
    alternateStdCode: formData.responsiblePersonSTDAlt || '',
    alternateTelephoneNo: formData.responsiblePersonTelephoneAlt || '',
    addressChangedSinceLastReturn:
      formData.responsiblePersonAddressChanged === 'Yes'
        ? true
        : formData.responsiblePersonAddressChanged === 'No'
          ? false
          : null,
    regularStatementFiledEarlier:
      formData.responsiblePersonRegularStatement === 'Yes'
        ? true
        : formData.responsiblePersonRegularStatement === 'No'
          ? false
          : null,
    earlierStatementReceiptNo: formData.responsiblePersonReceiptNumber,
  },
})
